var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.showTitle
      ? _c("h3", { staticClass: "text-end" }, [
          _vm._v(_vm._s(_vm.otherUserDisplay)),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        {
          staticClass: "card-body d-flex flex-column",
          class: { "pb-5": _vm.navRelative },
        },
        [
          _c(
            "div",
            {
              class: {
                "c-chat-content": _vm.navRelative,
                "c-overflow-y": _vm.navRelative,
              },
            },
            [
              _vm.prevPostId
                ? _c("div", { staticClass: "text-center" }, [
                    _c(
                      "span",
                      {
                        staticClass: "btn",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.fetchOlderPosts.apply(null, arguments)
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-chevron-up" })]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.orderedPostIds.length
                ? _c(
                    "span",
                    _vm._l(_vm.orderedPostIds, function (pid) {
                      return _c("div", { key: pid, staticClass: "mb-2" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _vm.posts[pid].showMenu
                              ? _c("channel-post-menu", {
                                  attrs: {
                                    post: _vm.posts[pid],
                                    direct: true,
                                    calendarData: _vm.getCalendarData(
                                      _vm.posts[pid]
                                    ),
                                  },
                                  on: {
                                    like: function ($event) {
                                      return _vm.reactToPost($event, "heart")
                                    },
                                    thumbsup: function ($event) {
                                      return _vm.reactToPost($event, "+1")
                                    },
                                    reply: function ($event) {
                                      return _vm.replyToPost($event)
                                    },
                                    edit: function ($event) {
                                      return _vm.editPost($event)
                                    },
                                    delete: function ($event) {
                                      return _vm.deletePost($event)
                                    },
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "card c-fit",
                                class: {
                                  "right-post":
                                    _vm.posts[pid].user_id == _vm.userId,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onPostClick(pid, $event)
                                  },
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "c-post card-body p-2",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.convert2Html(_vm.posts[pid].message)
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        pid in _vm.postReactions
                          ? _c(
                              "span",
                              {
                                staticClass: "c-reaction",
                                class: {
                                  "float-end":
                                    _vm.posts[pid].user_id == _vm.userId,
                                },
                              },
                              _vm._l(_vm.postReactions[pid], function (v, k) {
                                return _c(
                                  "button",
                                  {
                                    key: k,
                                    staticClass:
                                      "btn btn-sm btn-outline-light me-1",
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.reactToPost(pid, k)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticStyle: { color: "black" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.emojis[k] || k) +
                                            " " +
                                            _vm._s(v.size)
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                      ])
                    }),
                    0
                  )
                : _c("div", { staticClass: "text-center" }, [
                    _vm._v("\n          -- keine Nachrichten --\n        "),
                  ]),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "c-navbar": _vm.navRelative,
            "fixed-bottom": !_vm.navRelative,
          },
        },
        [
          _c("nav", { staticClass: "nav navbar navbar-light bg-light" }, [
            _c("form", { staticStyle: { width: "100%" } }, [
              _c("div", { staticClass: "input-group" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.postInput,
                      expression: "postInput",
                    },
                  ],
                  ref: "postInput",
                  staticClass: "form-control",
                  attrs: { rows: _vm.currentRows },
                  domProps: { value: _vm.postInput },
                  on: {
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        if (!$event.shiftKey) return null
                        $event.preventDefault()
                        return _vm.postMessage.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        if (!$event.ctrlKey) return null
                        $event.preventDefault()
                        return _vm.postMessage.apply(null, arguments)
                      },
                    ],
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.postInput = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.postMessage.apply(null, arguments)
                      },
                    },
                  },
                  [_c("span", { staticClass: "far fa-paper-plane" })]
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }